import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const phases = [{
    days: 'Día 1 al 3',
    title: 'Purga y Emergencia',
    desc: 'Ejecutas la purga digital y activas el protocolo de emergencia para superar el pico de ansiedad.'
  }, {
    days: 'Día 4 al 14',
    title: 'Hábitos Puente',
    desc: "Implementas los 'Hábitos Puente' para llenar el vacío químico con logros reales y ejercicio."
  }, {
    days: 'Día 15 al 21',
    title: 'Sellado Neuronal',
    desc: 'Sellas tu nuevo cableado neuronal y recuperas la sensibilidad hacia los estímulos normales de la vida.'
  }];
  return <section className="py-24 px-6 bg-[#09090b]" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <FadeIn data-id="element-85">
          <h2 className="font-bebas text-4xl sm:text-5xl uppercase tracking-wide text-center mb-16" data-id="element-86">
            El Plan de <span className="text-amber-500" data-id="element-87">21 Días</span>
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-88">
          {/* Vertical Line */}
          <div className="absolute left-6 sm:left-1/2 top-0 bottom-0 w-px bg-zinc-800 sm:-translate-x-1/2" data-id="element-89" />

          <div className="space-y-12" data-id="element-90">
            {phases.map((phase, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-91">
                <div className={`relative flex flex-col sm:flex-row items-start sm:items-center gap-8 ${index % 2 === 0 ? 'sm:flex-row-reverse' : ''}`} data-id="element-92">
                  {/* Timeline Dot */}
                  <div className="absolute left-6 sm:left-1/2 w-4 h-4 rounded-full bg-amber-500 border-4 border-[#09090b] -translate-x-1/2 mt-6 sm:mt-0 z-10 shadow-[0_0_10px_rgba(245,158,11,0.5)]" data-id="element-93" />

                  {/* Content Box */}
                  <div className={`w-full sm:w-1/2 pl-16 sm:pl-0 ${index % 2 === 0 ? 'sm:pr-12 text-left sm:text-right' : 'sm:pl-12 text-left'}`} data-id="element-94">
                    <div className="bg-zinc-900/80 border border-zinc-800 rounded-xl p-6 hover:border-amber-500/30 transition-colors" data-id="element-95">
                      <span className="inline-block px-3 py-1 bg-amber-500/10 text-amber-500 text-sm font-bold tracking-wider uppercase rounded-md mb-3" data-id="element-96">
                        {phase.days}
                      </span>
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-97">
                        {phase.title}
                      </h3>
                      <p className="text-zinc-400 leading-relaxed" data-id="element-98">
                        {phase.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}